import { FC } from 'react';

import { CustomAlert, CustomButton, Text } from '../../../shared/uiComponents';
import { ButtonWrapper } from '../../../components/StyledComponents';

interface DialogProps {
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
	open: boolean;
}

export const MBH_BILLING_WARNING_TITLE = 'Attention';

export const MBH_BILLING_WARNING_MESSAGE =
	'This session has been submitted to MBH for billing. Making changes may impact payroll processing. The payroll team will be notified of this change.';

export const MBH_BILLING_WARNING_CONFIRMATION = 'Are you sure you want to continue?';

export const DURATION_INCREASE_MESSAGE =
	"Increasing the session duration will change this note's status from Submitted back to Draft. The note will need to be re-submitted after review.";

export const DURATION_INCREASE_CONFIRMATION = 'Do you want to continue?';

const MBHBillingWarningContent: FC<{
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
}> = ({ onClose, onConfirm, loading }) => (
	<div style={{ textAlign: 'center' }}>
		<Text title={MBH_BILLING_WARNING_MESSAGE} className="padding16" type="psm" fontWeight="medium" />
		<Text title={MBH_BILLING_WARNING_CONFIRMATION} className="padding16" type="psm" fontWeight="semiBold" />
		<ButtonWrapper>
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
			<CustomButton title="Yes, Update Session" onClick={onConfirm} loading={loading} />
		</ButtonWrapper>
	</div>
);

export const MBHBillingWarningDialog: FC<DialogProps> = ({ open, onClose, onConfirm, loading }) => (
	<CustomAlert
		open={open}
		title={MBH_BILLING_WARNING_TITLE}
		onClose={onClose}
		Content={() => <MBHBillingWarningContent onClose={onClose} onConfirm={onConfirm} loading={loading} />}
	/>
);

const DurationIncreaseWarningContent: FC<{
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
}> = ({ onClose, onConfirm, loading }) => (
	<div style={{ textAlign: 'center' }}>
		<Text title={DURATION_INCREASE_MESSAGE} className="padding16" type="psm" fontWeight="medium" />
		<Text title={DURATION_INCREASE_CONFIRMATION} className="padding16" type="psm" fontWeight="semiBold" />
		<ButtonWrapper>
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
			<CustomButton title="Yes, Revert to Draft" onClick={onConfirm} loading={loading} />
		</ButtonWrapper>
	</div>
);

export const DurationIncreaseWarningDialog: FC<DialogProps> = ({ open, onClose, onConfirm, loading }) => (
	<CustomAlert
		open={open}
		title="Attention"
		onClose={onClose}
		Content={() => <DurationIncreaseWarningContent onClose={onClose} onConfirm={onConfirm} loading={loading} />}
	/>
);

const DurationIncreaseMBHWarningContent: FC<{
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
}> = ({ onClose, onConfirm, loading }) => (
	<div style={{ textAlign: 'center' }}>
		<Text title={MBH_BILLING_WARNING_MESSAGE} className="padding16" type="psm" fontWeight="medium" />
		<Text
			title={`Additionally, ${DURATION_INCREASE_MESSAGE.charAt(0).toLowerCase()}${DURATION_INCREASE_MESSAGE.slice(1)}`}
			className="padding16"
			type="psm"
			fontWeight="medium"
		/>
		<Text title={DURATION_INCREASE_CONFIRMATION} className="padding16" type="psm" fontWeight="semiBold" />
		<ButtonWrapper>
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
			<CustomButton title="Yes, Revert to Draft" onClick={onConfirm} loading={loading} />
		</ButtonWrapper>
	</div>
);

export const DurationIncreaseMBHWarningDialog: FC<DialogProps> = ({ open, onClose, onConfirm, loading }) => (
	<CustomAlert
		open={open}
		title="Attention"
		onClose={onClose}
		Content={() => <DurationIncreaseMBHWarningContent onClose={onClose} onConfirm={onConfirm} loading={loading} />}
	/>
);
